// AdminRotaSettingsPanel.jsx — admin-only per-department coverage rules.
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "../../ui/Toast";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const NEON = "#00FF99";

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

const EMPTY = {
  department: "Engineering",
  requires_24_7: false,
  min_staff_morning: 1, min_staff_afternoon: 1, min_staff_night: 0, min_staff_oncall: 0,
  requires_qualified_cover: false, qualification_tag: "",
};

export default function AdminRotaSettingsPanel() {
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const r = await fetch(`${API_BASE}/api/rota/team-settings`, { headers: authHeaders() });
    if (r.ok) setRows(await r.json());
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setSaving(true);
    const r = await fetch(`${API_BASE}/api/rota/team-settings`, {
      method: "POST",
      headers: { ...authHeaders(), "Content-Type": "application/json" },
      body: JSON.stringify(edit),
    });
    setSaving(false);
    if (r.ok) { load(); toast.success("Coverage rule saved"); }
    else toast.error("Save failed");
  };

  return (
    <div className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] p-5">
      <h3 className="text-sm text-[#00ff90]/70 uppercase tracking-widest mb-3">Team coverage rules</h3>

      <table className="w-full text-xs text-white/80 mb-4">
        <thead className="text-white/40 text-[10px] uppercase tracking-wider">
          <tr><th className="text-left py-1">Dept</th><th>24/7</th><th>Min M</th><th>Min A</th><th>Min N</th><th>On-call</th></tr>
        </thead>
        <tbody>
          {rows.map((s) => (
            <tr key={s.id} className="border-t border-white/5">
              <td className="py-1">{s.department}</td>
              <td className="text-center">{s.requires_24_7 ? "✓" : "—"}</td>
              <td className="text-center">{s.min_staff_morning}</td>
              <td className="text-center">{s.min_staff_afternoon}</td>
              <td className="text-center">{s.min_staff_night}</td>
              <td className="text-center">{s.min_staff_oncall}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={6} className="text-white/30 text-center py-2">No rules yet — add one below.</td></tr>
          )}
        </tbody>
      </table>

      <div className="grid grid-cols-2 md:grid-cols-7 gap-2 items-end">
        <input value={edit.department} onChange={(e) => setEdit({ ...edit, department: e.target.value })}
               placeholder="Department"
               className="col-span-2 bg-black border border-white/10 rounded px-2 py-1 text-xs text-white" />
        <label className="flex items-center gap-1 text-xs text-white/60">
          <input type="checkbox" checked={!!edit.requires_24_7}
            onChange={(e) => setEdit({ ...edit, requires_24_7: e.target.checked })} />
          24/7
        </label>
        {["min_staff_morning", "min_staff_afternoon", "min_staff_night", "min_staff_oncall"].map((k) => (
          <input key={k} type="number" min={0} max={20}
            value={edit[k]} onChange={(e) => setEdit({ ...edit, [k]: parseInt(e.target.value || "0", 10) })}
            className="bg-black border border-white/10 rounded px-2 py-1 text-xs text-white text-center" />
        ))}
        <button onClick={save} disabled={saving}
          className="col-span-1 px-3 py-1 rounded bg-[#00ff90]/15 text-[#00ff90] border border-[#00ff90]/40 text-xs">
          {saving ? "…" : "Save"}
        </button>
      </div>
      <p className="text-[10px] text-white/30 mt-2">Order: Morning · Afternoon · Night · On-call minimums.</p>
    </div>
  );
}
